import gql from 'graphql-tag';

export const Media = gql`
  fragment Media on Media {
    _id
    title
    filePath
    type
  }
`;
export const SimpleUser = gql`
  fragment SimpleUser on User {
    _id
    firstName
    lastName
    email
  }
`;

export const User = gql`
  fragment User on User {
    ...SimpleUser
    profileImage {
      ...Media
    }
    active
    role
    phone
    projects {
      _id
    }
  }
  ${SimpleUser}
  ${Media}
`;

export const SimpleSnippet = gql`
  fragment SimpleSnippet on Snippet {
    _id
    title
    language
    slug
    type
    project
  }
`;

export const Snippet = gql`
  fragment Snippet on Snippet {
    ...SimpleSnippet
    snippet
    description
  }
  ${SimpleSnippet}
`;

export const SimpleContent = gql`
  fragment SimpleContent on Content {
    _id
    title
    slug
    type
    project
  }
`;

export const Content = gql`
  fragment Content on Content {
    ...SimpleContent
    attachments {
      ...Media
    }
    ogImage {
      ...Media
    }
    content
    teaser
    seoTitle
    seoDescription
    linkToIndex
    position
    snippets {
      ...SimpleSnippet
    }
  }
  ${SimpleContent}
  ${Media}
  ${SimpleSnippet}
`;

export const SimpleNavigation = gql`
  fragment SimpleNavigation on Navigation {
    _id
    title
    project
  }
`;

export const Navigation = gql`
  fragment Navigation on Navigation {
    ...SimpleNavigation
  }
  ${SimpleNavigation}
`;



// WEBPACK FOOTER //
// ./src/qql-shared/fragments.js